<template>
  <div v-title data-title="提货已结束" class="mobile">
      <h4>提货已经结束，如有疑问，请联系相关人员！</h4>
  </div>
</template>

<script>
export default {
    name:"deliveryfinish"
}
</script>

<style  scoped>
.mobile{
  overflow: hidden;
  padding-top: 50px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/crab/deliveryfinish.vue